<template>
	<div class="Alipay-index-body">
		<!-- <form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway?charset=UTF-8&method=alipay.trade.page.pay&sign=oTTqkYOS0Is5jb1UczrV2pEIX7YxbKuokuR4nXHMKukpmnLZDIjPAn5QBYeavjRmx7T1795XHQf%2FYQxLQ%2BI9F%2BydCeYzKEH0UXtvxrUAXAct9EQ5zP6WxwZ8oH%2FdhfOIbNMkvoFTSSaY9IDNEzTEx6JYZzipvBCpUF17r9aEwPjkLn78o7F6rJCcV1D%2FIDxYaVslGA9kXkEjty%2B%2BvLDtKC6eeOcTgXoQ1q0jGtTA6J%2BKTIJFJA%2BaQ0K9HhRSORhgz5diIrNq7y2yFztSm57PwSR5%2FlvuQIWkUiQZdunq8kQgPFfqtH1G%2BHerpQ0buYfvhKlnxvhc47MLNsQAY44tzw%3D%3D&version=1.0&app_id=2021002152619071&sign_type=RSA2&timestamp=2021-06-28+16%3A36%3A51&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json">
		<input type="hidden" name="biz_content" value="{&quot;body&quot;:&quot;订单描述&quot;,&quot;out_trade_no&quot;:&quot;20200612000001&quot;,&quot;product_code&quot;:&quot;FAST_INSTANT_TRADE_PAY&quot;,&quot;subject&quot;:&quot;订单标题&quot;,&quot;total_amount&quot;:&quot;0.01&quot;}">
		<input type="submit" value="立即支付" style="display:none" >
		</form> -->
		<form name="punchout_form" method="post" action="https://openapi.alipay.com/gateway?charset=UTF-8&method=alipay.trade.page.pay&sign=Xc4xeoSTRuLemsWcFw3pFhJzyw%2BToHVv8WGQZSp3KXw6u%2F3De5UUKII%2FFV8qamhv3OmK4VtjcJF%2B63%2FM8sVWIIbQIrI6vsQv42He9HI2Hh9R0GWrosTtJN%2BsUAA%2BB7jkhL0sUTkLCBkdaNItcm8AI00tTk1ejjNnmSmzQmklAiToZJw5RVRVpTKK9XBkcLKL%2B%2B%2Fk0ZVdCMOZqxjsYv%2Bna7nexgt79baf67u3Rl2hpojKnTyDNf1XszTOmoiMKxOSJfOn%2FOH%2F6VDyWCUbE44HgpTECijx3cUWVDb2YuXZlZvNAUJk2Sg1eUSBdJIyzx6f4D5KDhFweLi%2BB3rSVMuJvQ%3D%3D&version=1.0&app_id=2021002152619071&sign_type=RSA2&timestamp=2021-06-28+16%3A43%3A11&alipay_sdk=alipay-sdk-java-dynamicVersionNo&format=json">
		<input type="hidden" name="biz_content" value="{&quot;body&quot;:&quot;订单描述&quot;,&quot;out_trade_no&quot;:&quot;20200612000001&quot;,&quot;product_code&quot;:&quot;FAST_INSTANT_TRADE_PAY&quot;,&quot;subject&quot;:&quot;订单标题&quot;,&quot;total_amount&quot;:&quot;0.1&quot;}">
		<input type="submit" value="立即支付" style="display:none" >
		</form>
		
		
	</div>
</template>

<script>
	import instance from "../../../utilities/customisedAxios";
	
	export default {
		//组件
		components: { 
			
		},
		//数据
		data(){
			return{
				
			}
		},
		//页面启动时
		created() {
			
		},
		//页面启动后
		mounted() {
			
			document.forms[0].submit();
		},
		computed: {
			
		},
		watch: {
			
		},
		//方法
		methods:{
			
		}
		
	}
</script>

<style>
	
</style>

<style scoped>
	
</style>
